module.exports = __webpack_public_path__ + "assets/5bf5c91891aba17f1cf1fde767d05ab6.png";